import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationDE from "./constants/locales/de/translation.json";
import translationEN from "./constants/locales/en/translation.json";

const resources = {
  de: {
    translation: translationDE,
  },
  en: {
    translation: translationEN,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "de",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
